export const SET_TASKS = 'SET_TASKS'
export const ADD_TASK = 'ADD_TASK'
export const SELECT_TASK = 'SELECT_TASK'
export const UPDATE_TASK = 'UPDATE_TASK'
export const DELETE_TASK = 'DELETE_TASK'

export const REGISTER = 'REGISTER'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const SET_USER = 'SET_USER'

export const SET_LOGIN_ERROR = 'SET_LOGIN_ERROR'
export const SET_TASK_ERROR = 'SET_TASK_ERROR'
export const SET_LOADING = 'SET_LOADING'
